async function init(element) {
    const {initSwiper} = await import('./swiper.js');
    return initSwiper(element);
}

async function initAll([element, ...elements]) {
    if (element)
        await init(element);

    if (elements.length > 0)
        return await initAll(elements);
}

const getSwiperRoots = () => document.querySelectorAll('.swiper-root');

BX.namespace('CarouselProducts');
BX.CarouselProducts.init = init;
BX.CarouselProducts.initAll = initAll;

document.addEventListener('DOMContentLoaded', () => initAll(getSwiperRoots()));
